export const userProfile = { "account_id": "6036249c783a4600687543d2", "email": "psharma4@atlassian.com", "name": "Prashant Sharma", "picture": "https://secure.gravatar.com/avatar/1834950c34b010663b2667dba952c142?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FPS-1.png", "account_status": "active", "characteristics": { "not_mentionable": false }, "last_updated": "2025-04-29T14:40:15.298Z", "nickname": "Prashant Sharma", "locale": "en-GB", "extended_profile": { "job_title": "Senior Frontend Software Engineer - Commerce IT", "organization": "Eng - Commerce Tech - Experiences", "department": "Commerce-IT", "phone_numbers": [], "team_type": "Software Development" }, "account_type": "atlassian", "email_verified": true }
export const subscriptionDetails = [
    {
        "cloudSiteId": "03c196c6-8925-43b0-9665-f4039be22e09",
        "hostname": "mod-checo-06.jira-dev.com",
        "hostingPlatform": "VERTIGO",
        "url": "https://mod-checo-06.jira-dev.com"
    },
    {
        "cloudSiteId": "11ecf06b-2523-4bb0-bcbf-b5ce8f579350",
        "hostname": "aura.jira-dev.com",
        "hostingPlatform": "VERTIGO",
        "url": "https://aura.jira-dev.com"
    },
    {
        "cloudSiteId": "165be6ff-29d3-403d-8c1c-336b248cb173",
        "hostname": "mod-checo-04.jira-dev.com",
        "hostingPlatform": "VERTIGO",
        "url": "https://mod-checo-04.jira-dev.com"
    },
    {
        "cloudSiteId": "26df53c3-fff2-4a1d-8dd9-7130778a1dcc",
        "hostname": "mod-checo-01.jira-dev.com",
        "hostingPlatform": "VERTIGO",
        "url": "https://mod-checo-01.jira-dev.com"
    },
    {
        "cloudSiteId": "33641ca0-adaa-4200-aef0-7b5290e77737",
        "hostname": "aura-test-105.jira-dev.com",
        "hostingPlatform": "VERTIGO",
        "url": "https://aura-test-105.jira-dev.com"
    },
    {
        "cloudSiteId": "35a239d9-d5a6-4190-a4e7-4092d84fe9a9",
        "hostname": "harshit-test-3.jira-dev.com",
        "hostingPlatform": "VERTIGO",
        "sen": "SEN-14231802",
        "url": "https://harshit-test-3.jira-dev.com"
    },
    {
        "cloudSiteId": "435d5220-2285-4461-a751-437628e7e35a",
        "hostname": "sainz-for-rb.jira-dev.com",
        "hostingPlatform": "VERTIGO",
        "url": "https://sainz-for-rb.jira-dev.com"
    },
    {
        "cloudSiteId": "6c8eca44-802e-4ee6-a966-b0ead30b0614",
        "hostname": "super-curd-rice.jira-dev.com",
        "hostingPlatform": "VERTIGO",
        "url": "https://super-curd-rice.jira-dev.com"
    },
    {
        "cloudSiteId": "72113bf8-fe94-4f46-b60e-292fb5d56cee",
        "hostname": "direct-to-partner-01.jira-dev.com",
        "hostingPlatform": "VERTIGO",
        "url": "https://direct-to-partner-01.jira-dev.com"
    },
    {
        "cloudSiteId": "75f34f1d-7139-47c1-939e-200d0d0cc8c0",
        "hostname": "cloud-test-itap-1716915247905sovvw.jira-dev.com",
        "hostingPlatform": "VERTIGO",
        "url": "https://cloud-test-itap-1716915247905sovvw.jira-dev.com"
    },
    {
        "cloudSiteId": "9840bb02-cbc0-4ed6-be57-8c798684cf1b",
        "hostname": "atl-vertigo--shard-jira-perf-us-6--supportuat4.jira-dev.com",
        "hostingPlatform": "VERTIGO",
        "url": "https://atl-vertigo--shard-jira-perf-us-6--supportuat4.jira-dev.com"
    },
    {
        "cloudSiteId": "afa5a1dd-0357-41d5-97c9-dd2b2c1b915b",
        "hostname": "masalaidli.jira-dev.com",
        "hostingPlatform": "VERTIGO",
        "url": "https://masalaidli.jira-dev.com"
    },
    {
        "cloudSiteId": "c0e708c3-50f0-4cfa-8dcc-0ff1233f60ba",
        "hostname": "direct-to-partner-02.jira-dev.com",
        "hostingPlatform": "VERTIGO",
        "url": "https://direct-to-partner-02.jira-dev.com"
    },
    {
        "cloudSiteId": "c8d77a25-37c5-40c4-bccb-ce0de149ad00",
        "hostname": "curdrice1.jira-dev.com",
        "aliases": [
            "curdrice.jira-dev.com"
        ],
        "hostingPlatform": "VERTIGO",
        "url": "https://curdrice1.jira-dev.com"
    },
    {
        "cloudSiteId": "d62af47a-54b2-4b23-bff7-cd21a5973f5f",
        "hostname": "xiex.jira-dev.com",
        "hostingPlatform": "VERTIGO",
        "sen": "SEN-14234801",
        "url": "https://xiex.jira-dev.com"
    },
    {
        "cloudSiteId": "eb4c50df-51b6-43d3-a9fd-8423754a5f74",
        "hostname": "mod-checo-05.jira-dev.com",
        "hostingPlatform": "VERTIGO",
        "url": "https://mod-checo-05.jira-dev.com"
    }
]